export default __webpack_public_path__ + "static/media/Aboutus@1.5x.46cc1f50.png";